<template>
  <div>
    <h5 class="headline">{{ $t('contract.other_regulations.headline') }}</h5>
    <p>{{ $t('contract.other_regulations.paragraph_one') }}</p>
    <p
      v-for="(regulation, index) in otherRegulations"
      :key="regulation.id"
    >{{ `17.${index+2}\t${regulation.text}` }}</p>
    <hr />
  </div>
</template>

<script>
export default {
  computed: {
    otherRegulations() {
      return this.$store.state.contract.otherRegulations;
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/apps/eneforhandler/components/contract/OtherRegulationsOutput.vue